const conf = {
  "enemy": [
    "Terminid",
    "Automaton",
    "Illuminate"
  ],
  "difficulty": [
    "1 - Trivial or greater",
    "2 - Easy or greater",
    "3 - Medium or greater",
    "4 - Challenging or greater",
    "5 - Hard or greater",
    "6 - Extreme or greater",
    "7 - Suicide Mission or greater",
    "8 - Impossible or greater",
    "9 - Helldive or greater",
    "10 - Super Helldive"
  ],
  "difficultyWeights": [
    0.0200000000, // "1 - Trivial or greater"
    0.0700000000, // "2 - Easy or greater"
    0.0700000000, // "3 - Medium or greater"
    0.1200000000, // "4 - Challenging or greater"
    0.1200000000, // "5 - Hard or greater"
    0.1200000000, // "6 - Extreme or greater"
    0.1200000000, // "7 - Suicide Mission or greater"
    0.1200000000, // "8 - Impossible or greater"
    0.1200000000, // "9 - Helldive or greater"
    0.1200000000, // "10 - Super Helldive"
  ],
  "duration": [
    "10 minute or more",
    "12 minute or more",
    "15 minute or more",
    "20 minute or more",
    "40 minute"
  ],
  "durationWeights": [
    0.0500000000, // "10 minute or more"
    0.0500000000, // "12 minute or more"
    0.0500000000, // "15 minute or more"
    0.0500000000, // "20 minute or more"
    0.8000000000, // "40 minute"
  ],
  "teamplay": [
    "Solo",
    "Squad"
  ],
  "teamplayWeights": [
    0.2000000000, // "Solo"
    0.8000000000, // "Squad"
  ],
  "stars": [
    "0 stars or more",
    "1 stars or more",
    "2 stars or more",
    "3 stars or more",
    "4 stars or more",
    "5 stars"
  ],
  "primary": [
    "AR-23 Liberator",
    "AR-23A Liberator Carbine",
    "AR-23C Liberator Concussive",
    "AR-23P Liberator Penetrator",
    "AR-61 Tenderizer",
    "ARC-12 Blitzer",
    "BR-14 Adjudicator",
    "CB-9 Exploding Crossbow",
    "FLAM-66 Torcher",
    "JAR-5 Dominator",
    "LAS-16 Sickle",
    "LAS-5 Scythe",
    "MP-98 Knight",
    "Plas-1 Scorcher",
    "Plas-101 Purifier",
    "R-2124 Constitution",
    "R-36 Eruptor",
    "R-63 Diligence",
    "R-63CS Diligence Counter Sniper",
    "SG-20 Halt",
    "SG-225 Breaker",
    "SG-225IE Breaker Incendiary",
    "SG-225SP Breaker SPRAY&PRAY",
    "SG-451 Cookout",
    "SG-8 Punisher",
    "SG-8P Punisher Plasma",
    "SG-8S Slugger",
    "SMG-32 Reprimand",
    "SMG-37 Defender",
    "SMG-72 Pummeler",
    "StA-52 Assault Rifle",
    "StA-11 SMG",
    "PLAS-39 Accelerator Rifle",
    "LAS-17 Double-Edge Sickle",
    "R-6 Deadeye",
    "R-2 Amendment",
    "AR-32 Pacifier",
    "VG-70 Variable",
    "MA5C Assault Rifle",
    "M7S SMG",
    "M90A Shotgun",
    "AR-2 Coyote",
    "AR/GL-21 One-Two",
    "DBS-2 Double Freedom",
    "R-72 Censor",
    "AR-59 Suppressor",
    "LAS-16 Trident",
    "SMG/FLAM-34 Stoker",
    "SG-225SP Sweeper",
    "SMG-203 Gallant",
    "R-4 Hyena",
    "R/40-K Hot-Shot",
  ],
  "primaryWeights": [
    0.0199428981, // "AR-23 Liberator"
    0.0200811048, // "AR-23A Liberator Carbine"
    0.0187437868, // "AR-23C Liberator Concussive"
    0.0169078048, // "AR-23P Liberator Penetrator"
    0.0194010326, // "AR-61 Tenderizer"
    0.0193506795, // "ARC-12 Blitzer"
    0.0199481768, // "BR-14 Adjudicator"
    0.0138656262, // "CB-9 Exploding Crossbow"
    0.0190152281, // "FLAM-66 Torcher"
    0.0179456893, // "JAR-5 Dominator"
    0.0206750929, // "LAS-16 Sickle"
    0.0185702557, // "LAS-5 Scythe"
    0.0197704502, // "MP-98 Knight"
    0.0200919806, // "Plas-1 Scorcher"
    0.0182579022, // "Plas-101 Purifier"
    0.0200791867, // "R-2124 Constitution"
    0.0138754244, // "R-36 Eruptor"
    0.0188058840, // "R-63 Diligence"
    0.0197227971, // "R-63CS Diligence Counter Sniper"
    0.0205346512, // "SG-20 Halt"
    0.0213336961, // "SG-225 Breaker"
    0.0188586721, // "SG-225IE Breaker Incendiary"
    0.0185396797, // "SG-225SP Breaker SPRAY&PRAY"
    0.0197498174, // "SG-451 Cookout"
    0.0197361277, // "SG-8 Punisher"
    0.0173370346, // "SG-8P Punisher Plasma"
    0.0189526954, // "SG-8S Slugger"
    0.0194791022, // "SMG-32 Reprimand"
    0.0199945878, // "SMG-37 Defender"
    0.0209584733, // "SMG-72 Pummeler"
    0.0193411313, // "StA-52 Assault Rifle"
    0.0192753035, // "StA-11 SMG"
    0.0204574305, // "PLAS-39 Accelerator Rifle"
    0.0196175120, // "LAS-17 Double-Edge Sickle"
    0.0186528247, // "R-6 Deadeye"
    0.0209275941, // "R-2 Amendment"
    0.0185076286, // "AR-32 Pacifier"
    0.0195870080, // "VG-70 Variable"
    0.0195165630, // "MA5C Assault Rifle"
    0.0199032285, // "M7S SMG"
    0.0185025299, // "M90A Shotgun"
    0.0194381100, // "AR-2 Coyote"
    0.0192366973, // "AR/GL-21 One-Two"
    0.0188421338, // "DBS-2 Double Freedom"
    0.0216756079, // "R-72 Censor"
    0.0191771352, // "AR-59 Suppressor"
    0.0186626376, // "LAS-16 Trident"
    0.0190120405, // "SMG/FLAM-34 Stoker"
    0.0202636835, // "SG-225SP Sweeper"
    0.0196619754, // "SMG-203 Gallant"
    0.0192156862, // "R-4 Hyena"
    0.0200000000, // "R/40-K Hot-Shot"
  ],
  "secondary": [
    "GP-31 Grenade Pistol",
    "LAS-7 Dagger",
    "P-2 Peacemaker",
    "P-4 Senator",
    "P-11 Stim Pistol",
    "P-19 Redeemer",
    "P-72 Crisper",
    "P-113 Verdict",
    "PLAS-15 Loyalist",
    "SG-22 Bushwhacker",
    "CQC-19 Stun Lance",
    "CQC-30 Stun Baton",
    "CQC-5 Combat Hatchet",
    "GP-31 Ultimatum",
    "LAS-58 Talon",
    "CQC-2 Saber",
    "P-92 Warrant",
    "M6C/SOCOM Pistol",
    "CQC-42 Machete",
    "P-35 Re-Educator",
    "CQC-73 Entrenchment Tool",
    "P-69 Veto",
    "P-33 Missile Pistol",
    "P/40-K Bolt Pistol",
  ],
  "secondaryWeights": [
    0.0324657493, // "GP-31 Grenade Pistol"
    0.0416413979, // "LAS-7 Dagger"
    0.0419192221, // "P-2 Peacemaker"
    0.0390027527, // "P-4 Senator"
    0.0499992755, // "P-11 Stim Pistol"
    0.0426406860, // "P-19 Redeemer"
    0.0395789775, // "P-72 Crisper"
    0.0447862738, // "P-113 Verdict"
    0.0435708831, // "PLAS-15 Loyalist"
    0.0420207653, // "SG-22 Bushwhacker"
    0.0418207309, // "CQC-19 Stun Lance"
    0.0413199879, // "CQC-30 Stun Baton"
    0.0410818963, // "CQC-5 Combat Hatchet"
    0.0421615051, // "GP-31 Ultimatum"
    0.0396075752, // "LAS-58 Talon"
    0.0457263133, // "CQC-2 Saber"
    0.0408997390, // "P-92 Warrant"
    0.0433152603, // "M6C/SOCOM Pistol"
    0.0460995984, // "CQC-42 Machete"
    0.0404247457, // "P-35 Re-Educator"
    0.0430414355, // "CQC-73 Entrenchment Tool"
    0.0455631618, // "P-69 Veto"
    0.0278120674, // "P-33 Missile Pistol"
    0.0435000000, // "P/40-K Bolt Pistol"
  ],
  "grenade": [
    "G-3 Smoke",
    "G-4 Gas Grenade",
    "G-6 Frag",
    "G-10 Incendiary",
    "G-12 High Explosive",
    "G-13 Incendiary Impact",
    "G-16 Impact",
    "G-23 Stun",
    "G-123 Thermite",
    "K-2 Throwing Knife",
    "G-50 Seeker",
    "TED-63 Dynamite",
    "G-142 Pyrotech",
    "G-109 Urchin",
    "G-31 Arc",
    "G-7 Pineapple",
    "TM-1 Lure Mine",
    "G/SH-39 Shield",
    "G-89 Smokescreen",
    "G-48 Giga Grenade",
    "G/40-K Melta Mine",
  ],
  "grenadeWeights": [
    0.0591822565, // "G-3 Smoke"
    0.0617001982, // "G-4 Gas Grenade"
    0.0345230979, // "G-6 Frag"
    0.0312841662, // "G-10 Incendiary"
    0.0349636689, // "G-12 High Explosive"
    0.0327516483, // "G-13 Incendiary Impact"
    0.0357743267, // "G-16 Impact"
    0.0592365163, // "G-23 Stun"
    0.0332261216, // "G-123 Thermite"
    0.0611028527, // "K-2 Throwing Knife"
    0.0648216890, // "G-50 Seeker"
    0.0342212350, // "TED-63 Dynamite"
    0.0344924756, // "G-142 Pyrotech"
    0.0593950371, // "G-109 Urchin"
    0.0627249268, // "G-31 Arc"
    0.0347032457, // "G-7 Pineapple"
    0.0604152007, // "TM-1 Lure Mine"
    0.0625363546, // "G/SH-39 Shield"
    0.0598774862, // "G-89 Smokescreen"
    0.0330674960, // "G-48 Giga Grenade"
    0.0500000000, // "G/40-K Melta Mine"
  ],
  "stratagem": [
    "A/AC-8 Autocannon Sentry",
    "A/ARC-3 Tesla Tower",
    "A/G-16 Gatling Sentry",
    "A/M-12 Mortar Sentry",
    "A/M-23 EMS Mortar Sentry",
    "A/MG-43 Machine Gun Sentry",
    "A/MLS-4X Rocket Sentry",
    "AC-8 Autocannon",
    "APW-1 Anti-Material Rifle",
    "ARC-3 Arc Thrower",
    "AX/AR-23 Guard Dog",
    "AX/TX-13 Guard Dog Dog Breath",
    "AX/LAS-5 Guard Dog Rover",
    "B-1 Supply Pack",
    "E/MG-101 HMG Emplacement",
    "Eagle 110m Rocket Pods",
    "Eagle 500kg Bomb",
    "Eagle Airstrike",
    "Eagle Cluster Bomb",
    "Eagle Napalm Airstrike",
    "Eagle Smoke Strike",
    "Eagle Strafing Run",
    "EAT-17 Expendable Anti-Tank",
    "EXO-45 Patriot Exosuit",
    "EXO-49 Emancipator Exosuit",
    "FAF-14 Spear",
    "FLAM-40 Flamethrower",
    "FX-12 Shield Generator Relay",
    "GL-21 Grenade Launcher",
    "GR-8 Recoilless Rifle",
    "LAS-98 Laser Cannon",
    "LAS-99 Quasar Cannon",
    "LIFT-850 Jump Pack",
    "M-105 Stalwart",
    "MD-6 Anti-Personnel Minefield",
    "MD-17 Anti-Tank Mines",
    "MD-I4 Incendiary Mines",
    "MG-206 Heavy Machine Gun",
    "MG-43 Machine Gun",
    "MLS-4X Commando",
    "Orbital 120MM HE Barrage",
    "Orbital 380MM HE Barrage",
    "Orbital Airburst Strike",
    "Orbital EMS Strike",
    "Orbital Gas Strike",
    "Orbital Gatling Barage",
    "Orbital Laser",
    "Orbital Napalm Barrage",
    "Orbital Precision Strike",
    "Orbital Railcannon Strike",
    "Orbital Smoke Strike",
    "Orbital Walking Barrage",
    "RL-77 Airburst Rocket Launcher",
    "RS-422 Railgun",
    "SH-20 Balistic Shield Backpack",
    "SH-32 Shield Generator Pack",
    "TX-41 Sterilizer",
    "SH-51 Directional Shield",
    "A/FLAM-40 Flame Sentry",
    "E/AT-12 Anti-Tank Emplacement",
    "M-102 Fast Recon Vehicle",
    "StA-X3 W.A.S.P. Launcher",
    "B-100 Portable Hellbomb",
    "MD-8 Gas Mines",
    "LIFT-860 Hover Pack",
    "E/GL-21 Grenadier Battlement",
    "CQC-1 One True Flag",
    "GL-52 De-Escalator",
    "AX/ARC-3 Guard Dog K-9",
    "Plas-45 Epoch",
    "A/LAS-98 Laser Sentry",
    "LIFT-182 Warp Pack",
    "MS-11 Solo Silo",
    "EAT-700 Expendable Napalm",
    "S-11 Speargun",
    "CQC-9 Defoliation Tool",
    "AZ/FLAM-75 Guard Dog Hot Dog",
    "M-1000 Maxigun",
    "B/MD C4 Pack",
    "GL-28 Belt-Fed Grenade Launcher",
    "EAT-411 Leveller",
    "CQC-20 Breaching Hammer",
    "TD-220 Bastion MK XVI",
    "A/GM-17 Gas Mortar Sentry",
    "B/FLAM-80 Cremator",
    "MGX-42 Bullet Storm",
    "EXO-51 Lumberer Exosuit",
    "EXO-55 Breakthrough Exosuit",
    "M-103 Supply FRV",
    "40-K Meltagun",
  ],
  "stratagemWeights": [
    0.0091889450, // "A/AC-8 Autocannon Sentry"
    0.0091349772, // "A/ARC-3 Tesla Tower"
    0.0087502571, // "A/G-16 Gatling Sentry"
    0.0091495454, // "A/M-12 Mortar Sentry"
    0.0090352219, // "A/M-23 EMS Mortar Sentry"
    0.0092320479, // "A/MG-43 Machine Gun Sentry"
    0.0091536091, // "A/MLS-4X Rocket Sentry"
    0.0000000007, // "AC-8 Autocannon"
    0.0000000007, // "APW-1 Anti-Material Rifle"
    0.0000000007, // "ARC-3 Arc Thrower"
    0.0463606608, // "AX/AR-23 Guard Dog"
    0.0474032311, // "AX/TX-13 Guard Dog Dog Breath"
    0.0460798797, // "AX/LAS-5 Guard Dog Rover"
    0.0468088792, // "B-1 Supply Pack"
    0.0093559110, // "E/MG-101 HMG Emplacement"
    0.0085605474, // "Eagle 110m Rocket Pods"
    0.0083141305, // "Eagle 500kg Bomb"
    0.0082086384, // "Eagle Airstrike"
    0.0092516209, // "Eagle Cluster Bomb"
    0.0087418060, // "Eagle Napalm Airstrike"
    0.0095106347, // "Eagle Smoke Strike"
    0.0083192365, // "Eagle Strafing Run"
    0.0000000007, // "EAT-17 Expendable Anti-Tank"
    0.0080310826, // "EXO-45 Patriot Exosuit"
    0.0079453638, // "EXO-49 Emancipator Exosuit"
    0.0000000007, // "FAF-14 Spear"
    0.0000000007, // "FLAM-40 Flamethrower"
    0.0135009673, // "FX-12 Shield Generator Relay"
    0.0000000007, // "GL-21 Grenade Launcher"
    0.0000000007, // "GR-8 Recoilless Rifle"
    0.0000000007, // "LAS-98 Laser Cannon"
    0.0000000007, // "LAS-99 Quasar Cannon"
    0.0441647403, // "LIFT-850 Jump Pack"
    0.0000000007, // "M-105 Stalwart"
    0.0090897003, // "MD-6 Anti-Personnel Minefield"
    0.0090680636, // "MD-17 Anti-Tank Mines"
    0.0086886616, // "MD-I4 Incendiary Mines"
    0.0000000007, // "MG-206 Heavy Machine Gun"
    0.0000000007, // "MG-43 Machine Gun"
    0.0000000007, // "MLS-4X Commando"
    0.0078786817, // "Orbital 120MM HE Barrage"
    0.0080376486, // "Orbital 380MM HE Barrage"
    0.0090810334, // "Orbital Airburst Strike"
    0.0093620211, // "Orbital EMS Strike"
    0.0089831151, // "Orbital Gas Strike"
    0.0090072515, // "Orbital Gatling Barage"
    0.0091471731, // "Orbital Laser"
    0.0086359596, // "Orbital Napalm Barrage"
    0.0093396515, // "Orbital Precision Strike"
    0.0091654310, // "Orbital Railcannon Strike"
    0.0101839735, // "Orbital Smoke Strike"
    0.0079792670, // "Orbital Walking Barrage"
    0.0000000007, // "RL-77 Airburst Rocket Launcher"
    0.0000000007, // "RS-422 Railgun"
    0.0479579170, // "SH-20 Balistic Shield Backpack"
    0.0450955367, // "SH-32 Shield Generator Pack"
    0.0000000007, // "TX-41 Sterilizer"
    0.0486499906, // "SH-51 Directional Shield"
    0.0091388022, // "A/FLAM-40 Flame Sentry"
    0.0090669311, // "E/AT-12 Anti-Tank Emplacement"
    0.0101202741, // "M-102 Fast Recon Vehicle"
    0.0000000007, // "StA-X3 W.A.S.P. Launcher"
    0.0453012250, // "B-100 Portable Hellbomb"
    0.0086969081, // "MD-8 Gas Mines"
    0.0453254779, // "LIFT-860 Hover Pack"
    0.0091161379, // "E/GL-21 Grenadier Battlement"
    0.0000000007, // "CQC-1 One True Flag"
    0.0000000007, // "GL-52 De-Escalator"
    0.0457096625, // "AX/ARC-3 Guard Dog K-9"
    0.0000000007, // "Plas-45 Epoch"
    0.0090380054, // "A/LAS-98 Laser Sentry"
    0.0465812341, // "LIFT-182 Warp Pack"
    0.0000000007, // "MS-11 Solo Silo"
    0.0000000007, // "EAT-700 Expendable Napalm"
    0.0000000007, // "S-11 Speargun"
    0.0000000007, // "CQC-9 Defoliation Tool"
    0.0464570246, // "AZ/FLAM-75 Guard Dog Hot Dog"
    0.0000000007, // "M-1000 Maxigun"
    0.0000000007, // "B/MD C4 Pack"
    0.0000000007, // "GL-28 Belt-Fed Grenade Launcher"
    0.0000000007, // "EAT-411 Leveller"
    0.0000000007, // "CQC-20 Breaching Hammer"
    0.0098194400, // "TD-220 Bastion MK XVI"
    0.0092867471, // "A/GM-17 Gas Mortar Sentry"
    0.0000000007, // "B/FLAM-80 Cremator"
    0.0000000007, // "MGX-42 Bullet Storm"
    0.0081667363, // "EXO-51 Lumberer Exosuit"
    0.0086271720, // "EXO-55 Breakthrough Exosuit"
    0.0099951875, // "M-103 Supply FRV"
    0.0000000007, // "40-K Meltagun"
  ],
  "supportStratagemWeights": [
    0.0216979701, // "AC-8 Autocannon"
    0.0367178051, // "APW-1 Anti-Material Rifle"
    0.0355403679, // "ARC-3 Arc Thrower"
    0.0277138802, // "EAT-17 Expendable Anti-Tank"
    0.0307951276, // "FAF-14 Spear"
    0.0322921757, // "FLAM-40 Flamethrower"
    0.0224459428, // "GL-21 Grenade Launcher"
    0.0210080605, // "GR-8 Recoilless Rifle"
    0.0352024563, // "LAS-98 Laser Cannon"
    0.0226250497, // "LAS-99 Quasar Cannon"
    0.0349755310, // "M-105 Stalwart"
    0.0372301375, // "MG-206 Heavy Machine Gun"
    0.0367208242, // "MG-43 Machine Gun"
    0.0225348717, // "MLS-4X Commando"
    0.0208540602, // "RL-77 Airburst Rocket Launcher"
    0.0355382120, // "RS-422 Railgun"
    0.0406622629, // "TX-41 Sterilizer"
    0.0246867927, // "StA-X3 W.A.S.P. Launcher"
    0.0358362236, // "CQC-1 One True Flag"
    0.0342832262, // "GL-52 De-Escalator"
    0.0377124201, // "Plas-45 Epoch"
    0.0328097665, // "MS-11 Solo Silo"
    0.0287345850, // "EAT-700 Expendable Napalm"
    0.0226532383, // "S-11 Speargun"
    0.0367485422, // "CQC-9 Defoliation Tool"
    0.0353242019, // "M-1000 Maxigun"
    0.0208730789, // "GL-28 Belt-Fed Grenade Launcher"
    0.0248336443, // "EAT-411 Leveller"
    0.0375513083, // "CQC-20 Breaching Hammer"
    0.0210190417, // "B/MD C4 Pack"
    0.0343016224, // "B/FLAM-80 Cremator"
    0.0268275726, // "MGX-42 Bullet Storm"
    0.0312500000, // "40-K Meltagun"
  ],
  // Backpack slot only (wiki Equipment Traits § Backpack). Not deployables; no mission-only items.
  "BackpackStratagems": [
    "AC-8 Autocannon",
    "AX/AR-23 Guard Dog",
    "AX/TX-13 Guard Dog Dog Breath",
    "AX/LAS-5 Guard Dog Rover",
    "B-1 Supply Pack",
    "FAF-14 Spear",
    "GR-8 Recoilless Rifle",
    "LIFT-850 Jump Pack",
    "RL-77 Airburst Rocket Launcher",
    "SH-20 Balistic Shield Backpack",
    "SH-32 Shield Generator Pack",
    "SH-51 Directional Shield",
    "StA-X3 W.A.S.P. Launcher",
    "B-100 Portable Hellbomb",
    "LIFT-860 Hover Pack",
    "AX/ARC-3 Guard Dog K-9",
    "LIFT-182 Warp Pack",
    "M-1000 Maxigun",
    "AZ/FLAM-75 Guard Dog Hot Dog",
    "B/MD C4 Pack",
    "GL-28 Belt-Fed Grenade Launcher",
    "B/FLAM-80 Cremator",
  ],
  "SupportWeaponStratagems": [
    "AC-8 Autocannon",
    "APW-1 Anti-Material Rifle",
    "ARC-3 Arc Thrower",
    "EAT-17 Expendable Anti-Tank",
    "FAF-14 Spear",
    "FLAM-40 Flamethrower",
    "GL-21 Grenade Launcher",
    "GR-8 Recoilless Rifle",
    "LAS-98 Laser Cannon",
    "LAS-99 Quasar Cannon",
    "M-105 Stalwart",
    "MG-206 Heavy Machine Gun",
    "MG-43 Machine Gun",
    "MLS-4X Commando",
    "RL-77 Airburst Rocket Launcher",
    "RS-422 Railgun",
    "TX-41 Sterilizer",
    "StA-X3 W.A.S.P. Launcher",
    "CQC-1 One True Flag",
    "GL-52 De-Escalator",
    "Plas-45 Epoch",
    "MS-11 Solo Silo",
    "EAT-700 Expendable Napalm",
    "S-11 Speargun",
    "CQC-9 Defoliation Tool",
    "M-1000 Maxigun",
    "GL-28 Belt-Fed Grenade Launcher",
    "EAT-411 Leveller",
    "CQC-20 Breaching Hammer",
    "B/MD C4 Pack",
    "B/FLAM-80 Cremator",
    "MGX-42 Bullet Storm",
    "40-K Meltagun",
  ],
  "VehicleStratagems": [
    "EXO-45 Patriot Exosuit",
    "EXO-49 Emancipator Exosuit",
    "EXO-51 Lumberer Exosuit",
    "EXO-55 Breakthrough Exosuit",
    "M-102 Fast Recon Vehicle",
    "M-103 Supply FRV",
  ],
  // OneHandedWeapons: Only support weapons and primary weapons usable with shields. Secondary weapons are always one-handed but handled separately — do NOT add them here.
  "OneHandedWeapons": [
    "MP-98 Knight",
    "SMG-37 Defender",
    "SMG-72 Pummeler",
    "StA-11 SMG",
    "CB-9 Exploding Crossbow",
    "CQC-1 One True Flag",
    "M7S SMG",
    "SMG/FLAM-34 Stoker",
    "SMG-203 Gallant",
  ],
  "MeleeWeapons": [
    "R-2124 Constitution",
    "R-2 Amendment",
    "CQC-19 Stun Lance",
    "CQC-30 Stun Baton",
    "CQC-5 Combat Hatchet",
    "CQC-2 Saber",
    "K-2 Throwing Knife",
    "CQC-1 One True Flag",
    "CQC-42 Machete",
    "CQC-9 Defoliation Tool",
    "CQC-20 Breaching Hammer",
    "CQC-73 Entrenchment Tool",
  ],
  "SmokeWeapons": [
    "G-3 Smoke",
    "Eagle Smoke Strike",
    "Orbital Smoke Strike",
    "G-89 Smokescreen",
  ],
  "SpawnerWeapons": {
    "Terminid": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol",
        "P-33 Missile Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
        "G-48 Giga Grenade",
        "G/40-K Melta Mine",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "RL-77 Airburst Rocket Launcher",
        "StA-X3 W.A.S.P. Launcher",
        "S-11 Speargun",
        "B/MD C4 Pack",
        "GL-28 Belt-Fed Grenade Launcher",
        "TD-220 Bastion MK XVI",
        "EXO-51 Lumberer Exosuit",
        "EXO-55 Breakthrough Exosuit",
        "40-K Meltagun",
      ]
    },
    "Automaton": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol",
        "P-33 Missile Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
        "G-48 Giga Grenade",
        "G/40-K Melta Mine",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "Eagle 110m Rocket Pods",
        "Eagle Napalm Airstrike",
        "Eagle 500kg Bomb",
        "Eagle Airstrike",
        "Eagle Strafing Run",
        "EAT-17 Expendable Anti-Tank",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "FAF-14 Spear",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "Orbital 120MM HE Barrage",
        "Orbital 380MM HE Barrage",
        "Orbital Napalm Barrage",
        "Orbital Walking Barrage",
        "RL-77 Airburst Rocket Launcher",
        "StA-X3 W.A.S.P. Launcher",
        "EAT-700 Expendable Napalm",
        "S-11 Speargun",
        "B/MD C4 Pack",
        "GL-28 Belt-Fed Grenade Launcher",
        "EAT-411 Leveller",
        "TD-220 Bastion MK XVI",
        "MGX-42 Bullet Storm",
        "EXO-51 Lumberer Exosuit",
        "EXO-55 Breakthrough Exosuit",
        "40-K Meltagun",
      ]
    },
    "Illuminate": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol",
        "P-33 Missile Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
        "G-48 Giga Grenade",
        "G/40-K Melta Mine",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "Eagle 500kg Bomb",
        "Eagle Airstrike",
        "Eagle Strafing Run",
        "EAT-17 Expendable Anti-Tank",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "Orbital 120MM HE Barrage",
        "Orbital 380MM HE Barrage",
        "Orbital Walking Barrage",
        "RL-77 Airburst Rocket Launcher",
        "EAT-700 Expendable Napalm",
        "S-11 Speargun",
        "B/MD C4 Pack",
        "GL-28 Belt-Fed Grenade Launcher",
        "EAT-411 Leveller",
        "TD-220 Bastion MK XVI",
        "MGX-42 Bullet Storm",
        "EXO-51 Lumberer Exosuit",
        "EXO-55 Breakthrough Exosuit",
        "40-K Meltagun",
      ]
    }
  }
};

export default conf;
